// source: wifi_scan.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var constants_pb = require('./constants_pb.js');
goog.object.extend(proto, constants_pb);
var wifi_constants_pb = require('./wifi_constants_pb.js');
goog.object.extend(proto, wifi_constants_pb);
goog.exportSymbol('proto.espressif.CmdScanResult', null, global);
goog.exportSymbol('proto.espressif.CmdScanStart', null, global);
goog.exportSymbol('proto.espressif.CmdScanStatus', null, global);
goog.exportSymbol('proto.espressif.RespScanResult', null, global);
goog.exportSymbol('proto.espressif.RespScanStart', null, global);
goog.exportSymbol('proto.espressif.RespScanStatus', null, global);
goog.exportSymbol('proto.espressif.WiFiScanMsgType', null, global);
goog.exportSymbol('proto.espressif.WiFiScanPayload', null, global);
goog.exportSymbol('proto.espressif.WiFiScanPayload.PayloadCase', null, global);
goog.exportSymbol('proto.espressif.WiFiScanResult', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.CmdScanStart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.espressif.CmdScanStart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.CmdScanStart.displayName = 'proto.espressif.CmdScanStart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.RespScanStart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.espressif.RespScanStart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.RespScanStart.displayName = 'proto.espressif.RespScanStart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.CmdScanStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.espressif.CmdScanStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.CmdScanStatus.displayName = 'proto.espressif.CmdScanStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.RespScanStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.espressif.RespScanStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.RespScanStatus.displayName = 'proto.espressif.RespScanStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.CmdScanResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.espressif.CmdScanResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.CmdScanResult.displayName = 'proto.espressif.CmdScanResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.WiFiScanResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.espressif.WiFiScanResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.WiFiScanResult.displayName = 'proto.espressif.WiFiScanResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.RespScanResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.espressif.RespScanResult.repeatedFields_, null);
};
goog.inherits(proto.espressif.RespScanResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.RespScanResult.displayName = 'proto.espressif.RespScanResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.WiFiScanPayload = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.espressif.WiFiScanPayload.oneofGroups_);
};
goog.inherits(proto.espressif.WiFiScanPayload, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.WiFiScanPayload.displayName = 'proto.espressif.WiFiScanPayload';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.CmdScanStart.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.CmdScanStart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.CmdScanStart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.CmdScanStart.toObject = function(includeInstance, msg) {
  var f, obj = {
    blocking: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    passive: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    groupChannels: jspb.Message.getFieldWithDefault(msg, 3, 0),
    periodMs: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.CmdScanStart}
 */
proto.espressif.CmdScanStart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.CmdScanStart;
  return proto.espressif.CmdScanStart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.CmdScanStart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.CmdScanStart}
 */
proto.espressif.CmdScanStart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlocking(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPassive(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setGroupChannels(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPeriodMs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.CmdScanStart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.CmdScanStart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.CmdScanStart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.CmdScanStart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlocking();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPassive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getGroupChannels();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getPeriodMs();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional bool blocking = 1;
 * @return {boolean}
 */
proto.espressif.CmdScanStart.prototype.getBlocking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.espressif.CmdScanStart} returns this
 */
proto.espressif.CmdScanStart.prototype.setBlocking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool passive = 2;
 * @return {boolean}
 */
proto.espressif.CmdScanStart.prototype.getPassive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.espressif.CmdScanStart} returns this
 */
proto.espressif.CmdScanStart.prototype.setPassive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional uint32 group_channels = 3;
 * @return {number}
 */
proto.espressif.CmdScanStart.prototype.getGroupChannels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.espressif.CmdScanStart} returns this
 */
proto.espressif.CmdScanStart.prototype.setGroupChannels = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 period_ms = 4;
 * @return {number}
 */
proto.espressif.CmdScanStart.prototype.getPeriodMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.espressif.CmdScanStart} returns this
 */
proto.espressif.CmdScanStart.prototype.setPeriodMs = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.RespScanStart.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.RespScanStart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.RespScanStart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.RespScanStart.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.RespScanStart}
 */
proto.espressif.RespScanStart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.RespScanStart;
  return proto.espressif.RespScanStart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.RespScanStart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.RespScanStart}
 */
proto.espressif.RespScanStart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.RespScanStart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.RespScanStart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.RespScanStart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.RespScanStart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.CmdScanStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.CmdScanStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.CmdScanStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.CmdScanStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.CmdScanStatus}
 */
proto.espressif.CmdScanStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.CmdScanStatus;
  return proto.espressif.CmdScanStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.CmdScanStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.CmdScanStatus}
 */
proto.espressif.CmdScanStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.CmdScanStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.CmdScanStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.CmdScanStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.CmdScanStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.RespScanStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.RespScanStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.RespScanStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.RespScanStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    scanFinished: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    resultCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.RespScanStatus}
 */
proto.espressif.RespScanStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.RespScanStatus;
  return proto.espressif.RespScanStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.RespScanStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.RespScanStatus}
 */
proto.espressif.RespScanStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScanFinished(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setResultCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.RespScanStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.RespScanStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.RespScanStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.RespScanStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScanFinished();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getResultCount();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional bool scan_finished = 1;
 * @return {boolean}
 */
proto.espressif.RespScanStatus.prototype.getScanFinished = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.espressif.RespScanStatus} returns this
 */
proto.espressif.RespScanStatus.prototype.setScanFinished = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional uint32 result_count = 2;
 * @return {number}
 */
proto.espressif.RespScanStatus.prototype.getResultCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.espressif.RespScanStatus} returns this
 */
proto.espressif.RespScanStatus.prototype.setResultCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.CmdScanResult.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.CmdScanResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.CmdScanResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.CmdScanResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    startIndex: jspb.Message.getFieldWithDefault(msg, 1, 0),
    count: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.CmdScanResult}
 */
proto.espressif.CmdScanResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.CmdScanResult;
  return proto.espressif.CmdScanResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.CmdScanResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.CmdScanResult}
 */
proto.espressif.CmdScanResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStartIndex(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.CmdScanResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.CmdScanResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.CmdScanResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.CmdScanResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartIndex();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional uint32 start_index = 1;
 * @return {number}
 */
proto.espressif.CmdScanResult.prototype.getStartIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.espressif.CmdScanResult} returns this
 */
proto.espressif.CmdScanResult.prototype.setStartIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 count = 2;
 * @return {number}
 */
proto.espressif.CmdScanResult.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.espressif.CmdScanResult} returns this
 */
proto.espressif.CmdScanResult.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.WiFiScanResult.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.WiFiScanResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.WiFiScanResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.WiFiScanResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    ssid: msg.getSsid_asB64(),
    channel: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rssi: jspb.Message.getFieldWithDefault(msg, 3, 0),
    bssid: msg.getBssid_asB64(),
    auth: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.WiFiScanResult}
 */
proto.espressif.WiFiScanResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.WiFiScanResult;
  return proto.espressif.WiFiScanResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.WiFiScanResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.WiFiScanResult}
 */
proto.espressif.WiFiScanResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSsid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setChannel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRssi(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBssid(value);
      break;
    case 5:
      var value = /** @type {!proto.espressif.WifiAuthMode} */ (reader.readEnum());
      msg.setAuth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.WiFiScanResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.WiFiScanResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.WiFiScanResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.WiFiScanResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSsid_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getChannel();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getRssi();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBssid_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = message.getAuth();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional bytes ssid = 1;
 * @return {!(string|Uint8Array)}
 */
proto.espressif.WiFiScanResult.prototype.getSsid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes ssid = 1;
 * This is a type-conversion wrapper around `getSsid()`
 * @return {string}
 */
proto.espressif.WiFiScanResult.prototype.getSsid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSsid()));
};


/**
 * optional bytes ssid = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSsid()`
 * @return {!Uint8Array}
 */
proto.espressif.WiFiScanResult.prototype.getSsid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSsid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.espressif.WiFiScanResult} returns this
 */
proto.espressif.WiFiScanResult.prototype.setSsid = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional uint32 channel = 2;
 * @return {number}
 */
proto.espressif.WiFiScanResult.prototype.getChannel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.espressif.WiFiScanResult} returns this
 */
proto.espressif.WiFiScanResult.prototype.setChannel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 rssi = 3;
 * @return {number}
 */
proto.espressif.WiFiScanResult.prototype.getRssi = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.espressif.WiFiScanResult} returns this
 */
proto.espressif.WiFiScanResult.prototype.setRssi = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bytes bssid = 4;
 * @return {!(string|Uint8Array)}
 */
proto.espressif.WiFiScanResult.prototype.getBssid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes bssid = 4;
 * This is a type-conversion wrapper around `getBssid()`
 * @return {string}
 */
proto.espressif.WiFiScanResult.prototype.getBssid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBssid()));
};


/**
 * optional bytes bssid = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBssid()`
 * @return {!Uint8Array}
 */
proto.espressif.WiFiScanResult.prototype.getBssid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBssid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.espressif.WiFiScanResult} returns this
 */
proto.espressif.WiFiScanResult.prototype.setBssid = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};


/**
 * optional WifiAuthMode auth = 5;
 * @return {!proto.espressif.WifiAuthMode}
 */
proto.espressif.WiFiScanResult.prototype.getAuth = function() {
  return /** @type {!proto.espressif.WifiAuthMode} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.espressif.WifiAuthMode} value
 * @return {!proto.espressif.WiFiScanResult} returns this
 */
proto.espressif.WiFiScanResult.prototype.setAuth = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.espressif.RespScanResult.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.RespScanResult.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.RespScanResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.RespScanResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.RespScanResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.espressif.WiFiScanResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.RespScanResult}
 */
proto.espressif.RespScanResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.RespScanResult;
  return proto.espressif.RespScanResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.RespScanResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.RespScanResult}
 */
proto.espressif.RespScanResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.espressif.WiFiScanResult;
      reader.readMessage(value,proto.espressif.WiFiScanResult.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.RespScanResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.RespScanResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.RespScanResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.RespScanResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.espressif.WiFiScanResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated WiFiScanResult entries = 1;
 * @return {!Array<!proto.espressif.WiFiScanResult>}
 */
proto.espressif.RespScanResult.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.espressif.WiFiScanResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.espressif.WiFiScanResult, 1));
};


/**
 * @param {!Array<!proto.espressif.WiFiScanResult>} value
 * @return {!proto.espressif.RespScanResult} returns this
*/
proto.espressif.RespScanResult.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.espressif.WiFiScanResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.espressif.WiFiScanResult}
 */
proto.espressif.RespScanResult.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.espressif.WiFiScanResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.espressif.RespScanResult} returns this
 */
proto.espressif.RespScanResult.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.espressif.WiFiScanPayload.oneofGroups_ = [[10,11,12,13,14,15]];

/**
 * @enum {number}
 */
proto.espressif.WiFiScanPayload.PayloadCase = {
  PAYLOAD_NOT_SET: 0,
  CMD_SCAN_START: 10,
  RESP_SCAN_START: 11,
  CMD_SCAN_STATUS: 12,
  RESP_SCAN_STATUS: 13,
  CMD_SCAN_RESULT: 14,
  RESP_SCAN_RESULT: 15
};

/**
 * @return {proto.espressif.WiFiScanPayload.PayloadCase}
 */
proto.espressif.WiFiScanPayload.prototype.getPayloadCase = function() {
  return /** @type {proto.espressif.WiFiScanPayload.PayloadCase} */(jspb.Message.computeOneofCase(this, proto.espressif.WiFiScanPayload.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.WiFiScanPayload.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.WiFiScanPayload.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.WiFiScanPayload} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.WiFiScanPayload.toObject = function(includeInstance, msg) {
  var f, obj = {
    msg: jspb.Message.getFieldWithDefault(msg, 1, 0),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cmdScanStart: (f = msg.getCmdScanStart()) && proto.espressif.CmdScanStart.toObject(includeInstance, f),
    respScanStart: (f = msg.getRespScanStart()) && proto.espressif.RespScanStart.toObject(includeInstance, f),
    cmdScanStatus: (f = msg.getCmdScanStatus()) && proto.espressif.CmdScanStatus.toObject(includeInstance, f),
    respScanStatus: (f = msg.getRespScanStatus()) && proto.espressif.RespScanStatus.toObject(includeInstance, f),
    cmdScanResult: (f = msg.getCmdScanResult()) && proto.espressif.CmdScanResult.toObject(includeInstance, f),
    respScanResult: (f = msg.getRespScanResult()) && proto.espressif.RespScanResult.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.WiFiScanPayload}
 */
proto.espressif.WiFiScanPayload.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.WiFiScanPayload;
  return proto.espressif.WiFiScanPayload.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.WiFiScanPayload} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.WiFiScanPayload}
 */
proto.espressif.WiFiScanPayload.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.espressif.WiFiScanMsgType} */ (reader.readEnum());
      msg.setMsg(value);
      break;
    case 2:
      var value = /** @type {!proto.espressif.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 10:
      var value = new proto.espressif.CmdScanStart;
      reader.readMessage(value,proto.espressif.CmdScanStart.deserializeBinaryFromReader);
      msg.setCmdScanStart(value);
      break;
    case 11:
      var value = new proto.espressif.RespScanStart;
      reader.readMessage(value,proto.espressif.RespScanStart.deserializeBinaryFromReader);
      msg.setRespScanStart(value);
      break;
    case 12:
      var value = new proto.espressif.CmdScanStatus;
      reader.readMessage(value,proto.espressif.CmdScanStatus.deserializeBinaryFromReader);
      msg.setCmdScanStatus(value);
      break;
    case 13:
      var value = new proto.espressif.RespScanStatus;
      reader.readMessage(value,proto.espressif.RespScanStatus.deserializeBinaryFromReader);
      msg.setRespScanStatus(value);
      break;
    case 14:
      var value = new proto.espressif.CmdScanResult;
      reader.readMessage(value,proto.espressif.CmdScanResult.deserializeBinaryFromReader);
      msg.setCmdScanResult(value);
      break;
    case 15:
      var value = new proto.espressif.RespScanResult;
      reader.readMessage(value,proto.espressif.RespScanResult.deserializeBinaryFromReader);
      msg.setRespScanResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.WiFiScanPayload.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.WiFiScanPayload.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.WiFiScanPayload} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.WiFiScanPayload.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMsg();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCmdScanStart();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.espressif.CmdScanStart.serializeBinaryToWriter
    );
  }
  f = message.getRespScanStart();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.espressif.RespScanStart.serializeBinaryToWriter
    );
  }
  f = message.getCmdScanStatus();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.espressif.CmdScanStatus.serializeBinaryToWriter
    );
  }
  f = message.getRespScanStatus();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.espressif.RespScanStatus.serializeBinaryToWriter
    );
  }
  f = message.getCmdScanResult();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.espressif.CmdScanResult.serializeBinaryToWriter
    );
  }
  f = message.getRespScanResult();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.espressif.RespScanResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional WiFiScanMsgType msg = 1;
 * @return {!proto.espressif.WiFiScanMsgType}
 */
proto.espressif.WiFiScanPayload.prototype.getMsg = function() {
  return /** @type {!proto.espressif.WiFiScanMsgType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.espressif.WiFiScanMsgType} value
 * @return {!proto.espressif.WiFiScanPayload} returns this
 */
proto.espressif.WiFiScanPayload.prototype.setMsg = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Status status = 2;
 * @return {!proto.espressif.Status}
 */
proto.espressif.WiFiScanPayload.prototype.getStatus = function() {
  return /** @type {!proto.espressif.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.espressif.Status} value
 * @return {!proto.espressif.WiFiScanPayload} returns this
 */
proto.espressif.WiFiScanPayload.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional CmdScanStart cmd_scan_start = 10;
 * @return {?proto.espressif.CmdScanStart}
 */
proto.espressif.WiFiScanPayload.prototype.getCmdScanStart = function() {
  return /** @type{?proto.espressif.CmdScanStart} */ (
    jspb.Message.getWrapperField(this, proto.espressif.CmdScanStart, 10));
};


/**
 * @param {?proto.espressif.CmdScanStart|undefined} value
 * @return {!proto.espressif.WiFiScanPayload} returns this
*/
proto.espressif.WiFiScanPayload.prototype.setCmdScanStart = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.espressif.WiFiScanPayload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.WiFiScanPayload} returns this
 */
proto.espressif.WiFiScanPayload.prototype.clearCmdScanStart = function() {
  return this.setCmdScanStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.WiFiScanPayload.prototype.hasCmdScanStart = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional RespScanStart resp_scan_start = 11;
 * @return {?proto.espressif.RespScanStart}
 */
proto.espressif.WiFiScanPayload.prototype.getRespScanStart = function() {
  return /** @type{?proto.espressif.RespScanStart} */ (
    jspb.Message.getWrapperField(this, proto.espressif.RespScanStart, 11));
};


/**
 * @param {?proto.espressif.RespScanStart|undefined} value
 * @return {!proto.espressif.WiFiScanPayload} returns this
*/
proto.espressif.WiFiScanPayload.prototype.setRespScanStart = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.espressif.WiFiScanPayload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.WiFiScanPayload} returns this
 */
proto.espressif.WiFiScanPayload.prototype.clearRespScanStart = function() {
  return this.setRespScanStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.WiFiScanPayload.prototype.hasRespScanStart = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional CmdScanStatus cmd_scan_status = 12;
 * @return {?proto.espressif.CmdScanStatus}
 */
proto.espressif.WiFiScanPayload.prototype.getCmdScanStatus = function() {
  return /** @type{?proto.espressif.CmdScanStatus} */ (
    jspb.Message.getWrapperField(this, proto.espressif.CmdScanStatus, 12));
};


/**
 * @param {?proto.espressif.CmdScanStatus|undefined} value
 * @return {!proto.espressif.WiFiScanPayload} returns this
*/
proto.espressif.WiFiScanPayload.prototype.setCmdScanStatus = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.espressif.WiFiScanPayload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.WiFiScanPayload} returns this
 */
proto.espressif.WiFiScanPayload.prototype.clearCmdScanStatus = function() {
  return this.setCmdScanStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.WiFiScanPayload.prototype.hasCmdScanStatus = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional RespScanStatus resp_scan_status = 13;
 * @return {?proto.espressif.RespScanStatus}
 */
proto.espressif.WiFiScanPayload.prototype.getRespScanStatus = function() {
  return /** @type{?proto.espressif.RespScanStatus} */ (
    jspb.Message.getWrapperField(this, proto.espressif.RespScanStatus, 13));
};


/**
 * @param {?proto.espressif.RespScanStatus|undefined} value
 * @return {!proto.espressif.WiFiScanPayload} returns this
*/
proto.espressif.WiFiScanPayload.prototype.setRespScanStatus = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.espressif.WiFiScanPayload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.WiFiScanPayload} returns this
 */
proto.espressif.WiFiScanPayload.prototype.clearRespScanStatus = function() {
  return this.setRespScanStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.WiFiScanPayload.prototype.hasRespScanStatus = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional CmdScanResult cmd_scan_result = 14;
 * @return {?proto.espressif.CmdScanResult}
 */
proto.espressif.WiFiScanPayload.prototype.getCmdScanResult = function() {
  return /** @type{?proto.espressif.CmdScanResult} */ (
    jspb.Message.getWrapperField(this, proto.espressif.CmdScanResult, 14));
};


/**
 * @param {?proto.espressif.CmdScanResult|undefined} value
 * @return {!proto.espressif.WiFiScanPayload} returns this
*/
proto.espressif.WiFiScanPayload.prototype.setCmdScanResult = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.espressif.WiFiScanPayload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.WiFiScanPayload} returns this
 */
proto.espressif.WiFiScanPayload.prototype.clearCmdScanResult = function() {
  return this.setCmdScanResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.WiFiScanPayload.prototype.hasCmdScanResult = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional RespScanResult resp_scan_result = 15;
 * @return {?proto.espressif.RespScanResult}
 */
proto.espressif.WiFiScanPayload.prototype.getRespScanResult = function() {
  return /** @type{?proto.espressif.RespScanResult} */ (
    jspb.Message.getWrapperField(this, proto.espressif.RespScanResult, 15));
};


/**
 * @param {?proto.espressif.RespScanResult|undefined} value
 * @return {!proto.espressif.WiFiScanPayload} returns this
*/
proto.espressif.WiFiScanPayload.prototype.setRespScanResult = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.espressif.WiFiScanPayload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.WiFiScanPayload} returns this
 */
proto.espressif.WiFiScanPayload.prototype.clearRespScanResult = function() {
  return this.setRespScanResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.WiFiScanPayload.prototype.hasRespScanResult = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * @enum {number}
 */
proto.espressif.WiFiScanMsgType = {
  TYPECMDSCANSTART: 0,
  TYPERESPSCANSTART: 1,
  TYPECMDSCANSTATUS: 2,
  TYPERESPSCANSTATUS: 3,
  TYPECMDSCANRESULT: 4,
  TYPERESPSCANRESULT: 5
};

goog.object.extend(exports, proto.espressif);
